export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14367.b21bf6e1.jpg";